export class CancelSearchAction {
    constructor() {
        this.name = 'CancelSearch';
        this.isDeviceAction = false;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FuY2VsU2VhcmNoQWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbHMvYWN0aW9ucy9DYW5jZWxTZWFyY2hBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsTUFBTSxPQUFPLGtCQUFrQjtJQUEvQjtRQUNrQixTQUFJLEdBQUcsY0FBYyxDQUFDO1FBQ3RCLG1CQUFjLEdBQUcsS0FBSyxDQUFDO0lBQ3pDLENBQUM7Q0FBQSJ9